import { render } from "./MessageCreate.vue?vue&type=template&id=c9e8a300"
import script from "./MessageCreate.vue?vue&type=script&lang=js"
export * from "./MessageCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__